import { StackedDataUtil } from '../../data-mapper/utils';
import { IHighChartsAttributesModel } from '../../models/high-charts-attributes.interface';
import { BaseChartWorker } from '../common';

/**
 * SplitColumnChartWorker: chart worker specific to the insight's split column chart.
 * @param {any} config JSON object representing the chart configuration.
 * @param {IHighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class SplitColumnChartWorker extends BaseChartWorker {
	constructor(config: any, highChartsAttributes: IHighChartsAttributesModel) {
		super(config, highChartsAttributes);
	}

	/**
	 * transformData: transform the data into consumable format for the scenario analysis column chart.
	 */
	public transformData(): void {
		const transformedData = StackedDataUtil.getSplitColumnStackedData(this.highChartsAttributes.tabData, this.highChartsAttributes.portfolioIndex,
			this.highChartsAttributes.customAttributes.categories, this.highChartsAttributes.customAttributes.scenario);
		const series = transformedData.series;
		this.config.series = series;
		this.config.xAxis.categories = this.highChartsAttributes.customAttributes.categories;
	}
}
